<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.66602 8.33203L10.3327 8.33203" :stroke="color" stroke-width="0.666667" stroke-linecap="round"/>
    <path d="M5.66602 10.332L8.33268 10.332" :stroke="color" stroke-width="0.666667" stroke-linecap="round"/>
    <path d="M3.66602 3.93203C3.66602 3.37198 3.66602 3.09195 3.77501 2.87804C3.87088 2.68988 4.02386 2.5369 4.21203 2.44102C4.42594 2.33203 4.70596 2.33203 5.26602 2.33203H8.33661C8.5812 2.33203 8.70349 2.33203 8.81858 2.35966C8.92062 2.38416 9.01816 2.42456 9.10763 2.47939C9.20855 2.54123 9.29503 2.62771 9.46798 2.80066L11.8641 5.19674C12.037 5.36969 12.1235 5.45616 12.1853 5.55708C12.2402 5.64655 12.2806 5.7441 12.3051 5.84613C12.3327 5.96122 12.3327 6.08352 12.3327 6.32811V12.0654C12.3327 12.6254 12.3327 12.9054 12.2237 13.1194C12.1278 13.3075 11.9748 13.4605 11.7867 13.5564C11.5728 13.6654 11.2927 13.6654 10.7327 13.6654H5.26602C4.70596 13.6654 4.42594 13.6654 4.21203 13.5564C4.02386 13.4605 3.87088 13.3075 3.77501 13.1194C3.66602 12.9054 3.66602 12.6254 3.66602 12.0654V3.93203Z" :stroke="color" stroke-width="0.666667"/>
    <path d="M8.33398 2.33203V4.73203C8.33398 5.29208 8.33398 5.57211 8.44298 5.78602C8.53885 5.97418 8.69183 6.12716 8.87999 6.22304C9.09391 6.33203 9.37393 6.33203 9.93398 6.33203H12.334" :stroke="color" stroke-width="0.666667"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#000000',
    }
  },
};
</script>
